import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const chargeOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
      display: false,
    },
    title: {
      // display: true,
      // text: 'Total Charges',
    },
  },
}
export const bookingOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top' as const,
      display: false,
    },
    title: {
      // display: true,
      // text: 'Total Bookings',
    },
  },
}

export function BarChart({ analytics }: { analytics: any }) {
  const labels =
    analytics?.dailyData?.map((data: any) => {
      const date = new Date(data.date)
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      })
    }) || []

  const chargeData = {
    labels,
    datasets: [
      {
        label: 'Total Charges',
        data:
          analytics?.dailyData?.map((data: any) =>
            data.totalCharge.toFixed(2)
          ) || [],
        backgroundColor: '#2A6DF4',
      },
    ],
  }
  const bookingData = {
    labels,
    datasets: [
      {
        label: 'Total Bookings',
        data:
          analytics?.dailyData?.map((data: any) =>
            data.totalBookings.toFixed(2)
          ) || [],
        backgroundColor: '#F9E795',
      },
    ],
  }
  return (
    <div>
      <div className='bar-cover'>
        <div className='half_top'>
          <h2>Total Booking Charge</h2>
        </div>
        <Bar options={chargeOptions} data={chargeData} />
      </div>
      <div className='bar-cover'>
        <div className='half_top'>
          <h2>Total Valid Bookings</h2>
        </div>
        <Bar options={bookingOptions} data={bookingData} />
      </div>
    </div>
  )
}
